import { Button, cn } from '@repo/shadcn';
import { Loader2Icon } from 'lucide-react';
import { FaTrash } from 'react-icons/fa';

import { ButtonProps } from './button.interface';

export const DeleteButton = ({
    label,
    onClick,
    disabled,
    size,
    isIconButton,
    className,
    type = 'button',
    isLoading = false,
}: ButtonProps) => {
    if (isIconButton) {
        return (
            <Button
                onClick={onClick}
                disabled={disabled || isLoading}
                type={type}
                variant={'outline'}
                size={size || 'icon'}
                aria-label={isIconButton ? label : undefined}
                className={cn(
                    'border-red-600 text-red-600 hover:bg-red-600 hover:text-white focus:ring-red-600',
                    'disabled:cursor-not-allowed disabled:border-red-300 disabled:bg-transparent disabled:text-red-300 disabled:hover:bg-transparent disabled:hover:text-red-300',
                    className,
                )}
            >
                {isLoading ? (
                    <Loader2Icon
                        className={'size-4 animate-spin disabled:text-red-500'}
                    />
                ) : (
                    <FaTrash />
                )}
            </Button>
        );
    }

    return (
        <Button
            onClick={onClick}
            disabled={disabled || isLoading}
            type={type}
            variant={'outline'}
            size={size || 'sm'}
            aria-label={isIconButton ? label : undefined}
            className={cn(
                'border-red-600 text-red-600 hover:bg-red-600 hover:text-white focus:ring-red-600',
                'disabled:cursor-not-allowed disabled:border-red-300 disabled:bg-transparent disabled:text-red-300 disabled:hover:bg-transparent disabled:hover:text-red-300',
            )}
        >
            {isLoading ? (
                <span>
                    <Loader2Icon className={'size-4 animate-spin'} />
                    'Processing...'
                </span>
            ) : (
                label ?? 'Delete'
            )}
        </Button>
    );
};

DeleteButton.displayName = 'DeleteButton';
